/**
 * RegionalSalesTraffic — "Regional Web Traffic" card: 7-day visit /
 * booking columns with a visits-bookings-conversion footer. Port of
 * the V3Sales web-traffic module.
 *
 * Behind <MockedOverlay> until web traffic lands (GA4 — BON-138).
 * Columns are neutral skeleton bars; footer renders em-dashes.
 */
import { MockedOverlay } from '../primitives';

const EM_DASH = '—';

/** Layout-only skeleton heights per weekday. */
const DAYS = [
  { day: 'Mon', pct: 42 },
  { day: 'Tue', pct: 55 },
  { day: 'Wed', pct: 38 },
  { day: 'Thu', pct: 61 },
  { day: 'Fri', pct: 78 },
  { day: 'Sat', pct: 92 },
  { day: 'Sun', pct: 70 },
] as const;

function FooterStat({ label }: { label: string }) {
  return (
    <span>
      <strong style={{ color: 'var(--nb-ink)' }}>{EM_DASH}</strong> {label}
    </span>
  );
}

export function RegionalSalesTraffic() {
  return (
    <section className="nb-card">
      <div className="nb-card-hd">
        <h3 className="nb-display" style={{ fontSize: 13, letterSpacing: '0.04em', margin: 0 }}>
          Regional Web Traffic
        </h3>
        <span className="nb-eyebrow">7 days</span>
      </div>
      <MockedOverlay reason="Regional web traffic comes from GA4 and isn't on the sales DTO yet. Tracked in BON-138.">
        <div style={{ display: 'flex', alignItems: 'flex-end', gap: 6, height: 84 }}>
          {DAYS.map((d) => (
            <div
              key={d.day}
              style={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'stretch',
                gap: 4,
              }}
            >
              <div
                style={{
                  flex: 1,
                  position: 'relative',
                  borderRadius: 3,
                  background: 'var(--nb-surface-2)',
                  overflow: 'hidden',
                }}
              >
                <div
                  style={{
                    position: 'absolute',
                    left: 0,
                    right: 0,
                    bottom: 0,
                    height: `${d.pct}%`,
                    background: 'var(--nb-border-2)',
                  }}
                />
              </div>
              <div style={{ fontSize: 9, textAlign: 'center', color: 'var(--nb-subtle)' }}>
                {d.day}
              </div>
            </div>
          ))}
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: 8,
            fontSize: 10.5,
            color: 'var(--nb-subtle)',
          }}
        >
          <FooterStat label="visits" />
          <FooterStat label="bookings" />
          <FooterStat label="conversion" />
        </div>
      </MockedOverlay>
    </section>
  );
}
